import { LuBrain, LuShirt, LuSparkles, LuWandSparkles } from "react-icons/lu";

/** Empty-state pills. Each pre-fills a request the agent can do today (see runners/planner.py). */
export const QUICK_ACTIONS = [
    { id: "virtual-tryon", label: "Virtual try-on", icon: LuShirt, prompt: "Try the garment on the person." },
    { id: "generate-image", label: "Generate image", icon: LuWandSparkles, prompt: "Generate an image from my description." },
    { id: "edit-image", label: "Edit image", icon: LuSparkles, prompt: "Edit this photo. Tell me what to change after you attach it." },
    { id: "understand", label: "Understand", icon: LuBrain, prompt: "What do you see in this photo?" },
];
